import {React,useState,useEffect} from 'react'
import { Container } from 'react-bootstrap'
import SliderCommentItem from '../SliderCommentItem/SliderCommentItem'
import './SliderComment.css'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import TitleSectionComponent from '../TitleSectionComponent/TitleSectionComponent';
import { TfiCommentsSmiley } from 'react-icons/tfi'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';
export default function SliderComment() {
    const [commentFeaturedList, setCommentFeaturedList] = useState([]);
    useEffect(()=>{
        axiosConfig.get("/api/Comments/featured").then((result) => {
            setCommentFeaturedList(result.data.data);
          })
    },[])
    return (
        <>

            <div className='slider-comment'>
                <Container>
                    <TitleSectionComponent title='دیدگاه برخی از دانشجوها' icon={<TfiCommentsSmiley />} />
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            1000: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            }
                        }}
                        modules={[Pagination, Autoplay]}
                        className="mySwiper"
                    >

                        {
                            commentFeaturedList?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <SliderCommentItem item={item} />
                                </SwiperSlide>
                            ))
                        }

                    </Swiper>
                </Container>
            </div>
        </>

    )
}
